import {AbilityBuilder} from '@casl/ability';
import {AccountProjection} from '@scalified-monorepo/shared/domain';
import {SampleAppAbility} from '../abilities';

/**
 * Define Sample domain business constraint policies
 *
 * Sample has minimal business constraints as it's primarily managed
 * through role-based permissions. Baseline permissions come from user roles.
 */
export function defineSamplePolicies(account: AccountProjection, builder: AbilityBuilder<SampleAppAbility>): void {
  // No business constraints currently defined for Sample domain
  // BUSINESS RULE: Add any immutable sample-specific constraints here
  // Examples (if needed in future):
  // - cannot(Action.Delete, 'SampleMaterial', {isInUse: true})
  //     .because('Cannot delete sample material that is in use');
  // - cannot(Action.Archive, 'SampleWorkType', {hasActiveEstimates: true})
  //     .because('Cannot archive work type with active estimates');
  // Currently, Sample domain has no immutable business rules.
  // All permissions (who can create/update/archive) come from database roles.
}
